enum CompanyType {
  Agency = 'agency',
  CorporateCompany = 'corporateCompany',
  Customer = 'customer',
  NorthernCables = 'northernCables',
}

export default CompanyType;
